import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });

    // Log to error tracking service (if available)
    // Example: logErrorToService(error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container" style={{ padding: '20px', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="card" style={{ maxWidth: '500px', textAlign: 'center' }}>
            <h2 style={{ color: '#ef4444', marginBottom: '16px' }}>⚠️ Something went wrong</h2>
            <p style={{ marginBottom: '16px', color: '#6b7280' }}>
              The application encountered an unexpected error. Don't worry, your data is safe.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ marginBottom: '16px', textAlign: 'left', fontSize: '12px' }}>
                <summary style={{ cursor: 'pointer', marginBottom: '8px', color: '#6b7280' }}>
                  Error Details (Development Only)
                </summary>
                <pre style={{ 
                  background: '#f3f4f6', 
                  padding: '12px', 
                  borderRadius: '8px', 
                  overflow: 'auto',
                  maxHeight: '200px',
                  fontSize: '11px'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div className="row gap" style={{ justifyContent: 'center', marginTop: '20px' }}>
              <button 
                className="btn primary" 
                onClick={this.handleRetry}
                style={{ maxWidth: '200px' }}
              >
                🔄 Reload App
              </button>
              <button 
                className="btn secondary" 
                onClick={() => window.location.href = '/'}
                style={{ maxWidth: '200px' }}
              >
                🏠 Go Home
              </button>
            </div>

            <p style={{ marginTop: '20px', fontSize: '12px', color: '#9ca3af' }}>
              If the problem persists, please contact support.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;







